module.exports = __webpack_public_path__ + "img/hg.3c07e6ba.jpg";